import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import { createApiWithPath } from "../../client";
import { FieldTypesResponseData } from "../../types/field-type";

interface FieldTypeSearchParams {
  q: string;
  limit?: number;
}

export const getData = async (params: FieldTypeSearchParams) => {
  const queryParams = new URLSearchParams();
  queryParams.append("search", params.q);
  if (params.limit !== undefined) {
    queryParams.append("limit", params.limit.toString());
  }

  const { data } = await createApiWithPath("crm").get<FieldTypesResponseData>(
    `/field-types?${queryParams.toString()}`,
  );

  return data;
};

export const useFieldTypeSearch = (
  params: FieldTypeSearchParams,
): QueryObserverBaseResult<FieldTypesResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.fieldTypeSearch(params),
    () => getData(params),
    {
      enabled: Boolean(params.q) && params.q.trim().length >= 2,
    },
  );
  return { data, ...props };
};
